export default {"src":"/_next/static/media/MarkerIcon.3cff8759.svg","height":84,"width":84};